"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addWhitelist = addWhitelist;
exports.batchDeleteWhitelist = batchDeleteWhitelist;
exports.deleteWhitelist = deleteWhitelist;
exports.getWhitelistPage = getWhitelistPage;
exports.queryMemberByPhoneOrCard = queryMemberByPhoneOrCard;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取白名单列表
function getWhitelistPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUserWhiteInvoice/page',
    method: 'get',
    params: query
  });
}

// 删除白名单
function deleteWhitelist(id) {
  return (0, _requestAuth.default)({
    url: '/xyUserWhiteInvoice',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 批量删除白名单
function batchDeleteWhitelist(ids) {
  return (0, _requestAuth.default)({
    url: '/xyUserWhiteInvoice/batchDelete',
    method: 'post',
    data: ids
  });
}

// 添加白名单
function addWhitelist(data) {
  return (0, _requestAuth.default)({
    url: '/xyUserWhiteInvoice/save',
    method: 'post',
    data: data
  });
}

// 查询会员(通过手机号或卡号)
function queryMemberByPhoneOrCard(query) {
  return (0, _requestAuth.default)({
    url: '/xyUsers/queryMember',
    method: 'get',
    params: query
  });
}